export enum ProductAttribute {
  Type = '1',
  Form = '2',
  UnitQuantity = '3',
  UnitOfMeasurement = '4',
  ServingSize = '5',
  ServingsPerPackage = '6',
  RecommendationsForUse = '7',
  ActiveIngredientsPerServing = '8',
  Contraindications = '9',
  StorageConditions = '10',
  ExpirationDate = '11',
  CountryOfOrigin = '12',
  SpecialTemperatureStorageConditions = '13',
  SpecialTemperatureModeOfTransportation = '14',
  FreezingWithoutLossOfProperties = '15',
  MinimumStorageTemperature = '16',
  MaximumNumberOfDaysAtMinimumStorageTemperature = '17',
  AdditionalPackagingAtSpecialTemperatureConditions = '18',
  DescriptionHtml = '19',
  NumberOfTechnicalConditions = '32',
  ScopeOfUse = '33',
  ManufacturerName = '34',
  ManufacturerLegalAddress = '35',
  AdverseReaction = '36',
  Dosage = '37',
  CaloriesInKcal = '38',
  ProteinInGrams = '39',
  FatInGrams = '40',
  CarbohydratesInGrams = '41',
  MethodOfUse = '42'
}

const {
  ActiveIngredientsPerServing,
  AdditionalPackagingAtSpecialTemperatureConditions,
  AdverseReaction,
  CaloriesInKcal,
  CarbohydratesInGrams,
  Contraindications,
  CountryOfOrigin,
  Dosage,
  ExpirationDate,
  FatInGrams,
  Form,
  FreezingWithoutLossOfProperties,
  ManufacturerLegalAddress,
  ManufacturerName,
  MaximumNumberOfDaysAtMinimumStorageTemperature,
  MethodOfUse,
  MinimumStorageTemperature,
  NumberOfTechnicalConditions,
  ProteinInGrams,
  RecommendationsForUse,
  ScopeOfUse,
  ServingSize,
  ServingsPerPackage,
  SpecialTemperatureModeOfTransportation,
  SpecialTemperatureStorageConditions,
  StorageConditions,
  Type,
  UnitOfMeasurement,
  UnitQuantity
} = ProductAttribute

const exampleMapping = new Map([
  [
    ActiveIngredientsPerServing,
    'Мелатонин — 0,3 мг;\n'
    + '5НТР (гриффония) — 1,8 мг;\n'
    + 'Р5Р (витамин B6) — 2,5 мг;\n'
    + 'ацерола 17% — 3,6 мг (соответствует чистому витамину C в 0,6 мг)'
  ],
  [Contraindications, 'Индивидуальная непереносимость компонентов, беременность, кормление грудью'],
  [CountryOfOrigin, 'Россия'],
  [Dosage, '400 мг'],
  [ExpirationDate, '2 года'],
  [RecommendationsForUse, 'Взрослым по 2 капсулы 1 раз в день за 30—60 минут до сна'],
  [ServingSize, '2 капсулы'],
  [ServingsPerPackage, '60'],
  [
    StorageConditions,
    'Хранить в защищённом от прямых солнечных лучей месте при температуре от 0 до +25 °С и относительной влажности '
    + 'не более 75%. После вскрытия хранить только в холодильнике. Хранить в недоступном для детей месте'
  ]
])

const maxLengthMapping = new Map([
  [ActiveIngredientsPerServing, 8192],
  [AdverseReaction, 8192],
  [CaloriesInKcal, 255],
  [CarbohydratesInGrams, 255],
  [Contraindications, 8192],
  [CountryOfOrigin, 255],
  [Dosage, 255],
  [ExpirationDate, 255],
  [FatInGrams, 255],
  [ManufacturerLegalAddress, 255],
  [ManufacturerName, 255],
  [MaximumNumberOfDaysAtMinimumStorageTemperature, 255],
  [MethodOfUse, 255],
  [MinimumStorageTemperature, 255],
  [NumberOfTechnicalConditions, 255],
  [ProteinInGrams, 255],
  [RecommendationsForUse, 8192],
  [ScopeOfUse, 8192],
  [ServingSize, 255],
  [ServingsPerPackage, 255],
  [SpecialTemperatureModeOfTransportation, 255],
  [SpecialTemperatureStorageConditions, 255],
  [StorageConditions, 8192],
  [UnitQuantity, 255]
])

const nameMapping = new Map([
  [ActiveIngredientsPerServing, 'Активные вещества на 1 порцию'],
  [AdditionalPackagingAtSpecialTemperatureConditions, 'Дополнительная упаковка на период обеспечения специального температурного режима'],
  [AdverseReaction, 'Побочные действия'],
  [CaloriesInKcal, 'Калорийность, ккал'],
  [CarbohydratesInGrams, 'Углеводы, г'],
  [Contraindications, 'Противопоказания'],
  [CountryOfOrigin, 'Страна-производитель'],
  [Dosage, 'Разовая дозировка'],
  [ExpirationDate, 'Срок годности'],
  [FatInGrams, 'Жиры, г'],
  [Form, 'Форма'],
  [FreezingWithoutLossOfProperties, 'Заморозка без потери свойств'],
  [ManufacturerLegalAddress, 'Юридический адрес организации-изготовителя'],
  [ManufacturerName, 'Название организации-изготовителя'],
  [MaximumNumberOfDaysAtMinimumStorageTemperature, 'Максимальное количество дней при минимальной температуре хранения, дней'],
  [MethodOfUse, 'Способ применения'],
  [MinimumStorageTemperature, 'Минимальная температура хранения, °C'],
  [NumberOfTechnicalConditions, 'Номер технических условий'],
  [ProteinInGrams, 'Белки, г'],
  [RecommendationsForUse, 'Рекомендации по применению'],
  [ScopeOfUse, 'Область применения'],
  [ServingSize, 'Размер одной порции'],
  [ServingsPerPackage, 'Количество порций в упаковке'],
  [SpecialTemperatureModeOfTransportation, 'Специальный температурный режим транспортировки, °C'],
  [SpecialTemperatureStorageConditions, 'Специальные температурные условия хранения, °C'],
  [StorageConditions, 'Условия хранения'],
  [Type, 'Тип'],
  [UnitOfMeasurement, 'Единица измерения'],
  [UnitQuantity, 'Величина']
])

export const ProductAttributeUtils = {
  formatValue: (x: ProductAttribute, value: string | null): string | null => {
    if (value === null) {
      return null
    }

    if ([AdditionalPackagingAtSpecialTemperatureConditions, FreezingWithoutLossOfProperties].includes(x)) {
      switch (value) {
        case '1':
          return 'Да'
        case '0':
          return 'Нет'
        default:
          return value
      }
    }

    return value
  },
  getExample: (x: ProductAttribute): string => exampleMapping.get(x)!,
  getMaxLength: (x: ProductAttribute): number => maxLengthMapping.get(x)!,
  getName: (x: ProductAttribute): string => nameMapping.get(x)!
}
